/**
 * LangServer 모듈 목록 React Query Hook
 */
import { useQuery } from '@tanstack/react-query';

import { fetchModules } from '@/entities/langserver/api/fetchModules';
import type { ModuleTarget } from '@/entities/langserver/api/types';

export const useModules = (target: ModuleTarget, clientId: string, enabled = true) => {
  return useQuery({
    queryKey: ['langserver', 'modules', target, clientId],
    queryFn: () => fetchModules(target, clientId),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
};
